async function findUniqueFileName(directory, fileName, maxAttempts = 100) {
  const [name, ext] = fileName.split(/(?<=^[^.]*)\./);

  try {
    await directory.getFileHandle(fileName);
  } catch {
    return fileName;
  }

  for (let i = 1; i <= maxAttempts; i++) {
    const testName = `${name} (${i})${ext ? `.${ext}` : ''}`;
    try {
      await directory.getFileHandle(testName);
    } catch {
      return testName;
    }
  }

  throw new Error('Arquivo com nome duplicado');
}

export default {
  /**
   * Baixa um arquivo apartir de um link
   * @param {*} window objeto window
   * @param {*} link link do arquivo a ser baixado
   */
  async download(window, link) {
    try {
      const response = await fetch(link);

      if (!response.ok) {
        return { success: false };
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = response.url.split('/').pop();

      document.body.appendChild(a);
      a.click();

      a.remove();

      return { success: true };
    } catch (error) {
      return { success: false, errorMessage: error.errorMessage };
    }
  },

  /**
   * Baixa um arquivo apartir de um link
   * @param {*} window objeto window
   * @param {*} bffeer buffer do arquivo a ser baixado
   * @param {*} fileName nome do arquivo
   */
  async downloadFromBuffer(window, buffer, fileName) {
    try {
      const blob = new Blob([buffer]);

      if (!blob) {
        return { success: false };
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      return { success: false, errorMessage: error.errorMessage };
    }
  },

  async downloadManyChooseDirectoryFromBase64(window, files) {
    try {
      const directory = await window.showDirectoryPicker();

      for (const { filename, mimeType, base64 } of files) {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
        const byteArrays = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArrays], { type: mimeType });
        const originalName =
          decodeURIComponent(filename).split('/').pop() || 'arquivo';
        const uniqueFileName = await findUniqueFileName(
          directory,
          originalName,
        );
        const fileHandle = await directory.getFileHandle(uniqueFileName, {
          create: true,
        });
        const writable = await fileHandle.createWritable();
        await writable.write(blob);
        await writable.close();
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error(error);
      throw new Error('Erro ao baixar os arquivos');
    }
  },
};
